import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { Link } from 'react-router'
import { getI18n, getI18nBase } from 'client/i18n'
import CharityCard from 'components/common/charity_card'
import TextBox from 'components/common/text_box'
import MoneyTextBox from 'components/common/money_text_box'
import DateInputBox from 'components/common/date_input_box'
import DropDown from 'components/common/dropdown'
import CrowdFundingCoverImage from 'components/crowdfunding_cover_image'
import CrowdFundingPreview from 'components/pages/crowdfunding/crowdfunding_preview'
import StandardDialog from 'components/common/standard_dialog'
import {
  DESCRIPTION_ROWS,
  CROWDFUNDING_DESCRIPTION_LENGTH,
} from 'shared/lengths'
import styles from './edit_main_cf.less'
import { appendPath } from 'lib/route_utils'
import { formatDateShort } from 'client/griffin'
import {
  HeadingText,
  CaptionText,
  TrashIcon,
  Modal,
} from '@paypalcorp/pp-react'
import { trackClick, trackImpression } from 'lib/fpti_analytics'
import Separator from 'components/common/separator'
import _get from 'lodash/get'
import { INVALID_IMAGE, TOAST_NOTIFICATIONS } from 'shared/shared_consts'
import { decodeCampaignId } from 'shared/campaign_url'

const i18n = getI18n('components/edit_glimpse/edit_main')
const i18nBase = getI18nBase('components/edit_glimpse/edit_main')
const i18nGoalAmount = getI18n('components/pages/crowdfunding/pool_basics')

const getGoalAmountTitle = (charity, formattedMaxGoalAmount) => {
  if (charity) {
    return i18nGoalAmount('goal_amount_title_gnc')
  }
  return i18nBase('amount_cf', {
    maxGoalAmount: formattedMaxGoalAmount,
  })
}
class EditMain extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    ended: PropTypes.bool,
    showDelete: PropTypes.bool,
    location: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    onReopen: PropTypes.func,
    onSave: PropTypes.func,
    handleSubmit: PropTypes.func,
    isAndroid: PropTypes.bool,
    category: PropTypes.string,
    categoryList: PropTypes.array,
    router: PropTypes.object,
    campaign: PropTypes.object,
    stepRef: PropTypes.func,
    dirty: PropTypes.bool,
    formattedMaxGoalAmount: PropTypes.string,
    charity: PropTypes.object,
    onToggleToast: PropTypes.func,
  }

  state = {
    charCount: 0,
    isOpen: false,
    editedCampagin: this.props.campaign,
    showBackDialog: false,
    callback: null,
    showDeleteDialog: false,
  }

  handleKeyUp = e => {
    const content = e.target.value.length
    this.setState({
      charCount: content,
    })
  }

  handleModalClick = e => {
    e.preventDefault()
    this.trackEvents('dw_giving_edit_fundraiser_preview_pressed')
    this.setData()
  }

  handleModalClose = () => {
    this.setState({ isOpen: false })
    trackClick({
      clickName: 'dw_giving_fundraiser_preview_dismiss_pressed',
      data: {
        event_name: 'dw_giving_fundraiser_preview_dismiss_pressed',
        dismiss_method: 'close',
        ...this.getFTPITags(),
      },
    })
    this.trackEvents('dw_giving_fundraiser_preview_dismiss_pressed')
  }

  setData() {
    const {
      fields: {
        poolName,
        endDate,
        goalAmount,
        category,
        description,
        backgroundImage,
        backgroundImageFilename,
        backgroundPan,
        gradientColor,
      },
    } = this.props
    let newCampaign = Object.assign(this.state.editedCampagin, {
      goal: goalAmount.value || 0,
      category: category.value,
      description: description.value,
      end_date: endDate.value,
      title: poolName.value,
      gradient_color: gradientColor.value,
      background_image: backgroundImage.value,
      background_image_filename: backgroundImageFilename.value,
      background_pan: backgroundPan.value,
    })
    this.setState({
      editedCampagin: newCampaign,
      isOpen: true,
    })
    trackImpression({
      event_name: 'dw_giving_fundraiser_preview_screen_shown',
      ...this.getFTPITags(),
    })
  }

  handleSubmit = formValues => {
    const saveEvent = this.state.showBackDialog
      ? 'dw_giving_quit_editing_fundraiser_save_pressed'
      : 'dw_giving_edit_fundraiser_save_pressed'
    this.trackEvents(saveEvent)
    this.setState({ showBackDialog: false, callback: null })
    return this.props
      .onSave(formValues)
      .then(() => {
        this.editBack()
        this.props.onToggleToast(TOAST_NOTIFICATIONS.EDIT_SUCCESS)
      })
      .catch(err => {
        if (err.error === INVALID_IMAGE) {
          this.props.router.push({
            pathname: appendPath(location.pathname, 'manage/error'),
          })
        }
        this.props.router.push({
          pathname: appendPath(location.pathname, 'error'),
          state: { updateData: err.updateData },
        })
      })
  }

  componentDidMount() {
    if (this.props.stepRef) {
      this.props.stepRef(this)
    }
  }

  editBack = () => {
    const {
      params: { hideBack = false, campaignId = '' } = {},
    } = this.props.router
    if (hideBack) {
      this.props.router.push({
        pathname: `/pools/c/${campaignId}/edit/manage`,
      })
    } else {
      this.props.router.goBack()
    }
  }

  confirmNavigation = callback => {
    this.trackEvents('dw_giving_edit_fundraiser_quit_pressed')
    if (this.props.dirty) {
      this.setState({ showBackDialog: true, callback })
      trackImpression({
        event_name: 'dw_giving_quit_editing_fundraiser_screen_shown',
        ...this.getFTPITags(),
      })
    } else {
      this.editBack()
    }
  }

  getFTPITags = () => {
    const { campaign } = this.props
    return {
      flow: this.props.charity
        ? 'GENEROSITY_NETWORK_CHARITIES'
        : 'GENEROSITY_NETWORK',
      campaignId: decodeCampaignId(campaign.id),
    }
  }

  handleDialogClose = () => {
    this.setState({ showBackDialog: false })
  }

  handledeleteDialogClose = () => {
    this.trackEvents('dw_giving_delete_fundraiser_cancel_pressed')
    this.setState({ showDeleteDialog: false })
  }

  handleDeleteOk = () => {
    this.trackEvents('dw_giving_delete_fundraiser_confirm_pressed')
    /*this.props.router.push({
      pathname: glimpseRoute('edit', 'delete/review'),
    })*/
  }

  handleQuit = () => {
    this.trackEvents('dw_giving_quit_editing_fundraiser_without_save_pressed')
    this.editBack()
    this.setState({ showBackDialog: false, callback: null })
  }

  trackEvents = event_name => {
    trackClick({
      clickName: event_name,
      data: {
        event_name,
        ...this.getFTPITags(),
      },
    })
  }

  handleDelete = () => {
    this.trackEvents('dw_giving_edit_fundraiser_delete_pressed')

    this.setState({
      showDeleteDialog: true,
    })
    trackImpression({
      event_name: 'dw_giving_delete_fundraiser_screen_shown',
      ...this.getFTPITags(),
    })
  }

  render() {
    const {
      fields: {
        poolName,
        goalAmount,
        endDate,
        category,
        description,
        anyInactiveFieldsTouchedWithError,
      },
      charity,
      formattedMaxGoalAmount,
    } = this.props
    const { handleSubmit } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        {this.state.showBackDialog && (
          <StandardDialog
            size="medium"
            title={i18n('dirty_dialog_title_cf')}
            subtitle={i18n('dirty_dialog_subtitle_cf')}
            closeButtonTitle={i18n('quit_editing')}
            okButtonTitle={i18n('save_changes')}
            onClose={this.handleDialogClose}
            onOk={this.handleDialogOk}
            onQuit={this.handleQuit}
          />
        )}
        {this.state.showDeleteDialog && (
          <StandardDialog
            size="medium"
            title={i18n('delete_title_cf')}
            subtitle={i18n(
              `${charity ? 'delete_subtitle_cf_gnc' : 'delete_subtitle_cf'}`
            )}
            closeButtonTitle={i18n('keep_cf')}
            okButtonTitle={i18n('delete_cf')}
            onClose={this.handledeleteDialogClose}
            onOk={this.handleDeleteOk}
            isDelete={true}
          />
        )}
        <HeadingText size="lg" styleName="title">
          {i18n('edit_title_cf')}
        </HeadingText>
        {charity && (
          <>
            <div styleName="charity-header">{i18n('charity')}</div>
            <CharityCard charity={charity} />
            <div styleName="charity-subtitle">{i18n('charity_subtitle')}</div>
          </>
        )}
        <CaptionText styleName="detail-title">
          {i18n('detail_title_cf')}
        </CaptionText>
        {this.props.ended && (
          <div styleName="ended-title">
            {i18n('ended', {
              endDate: formatDateShort(endDate.value),
            })}
          </div>
        )}
        <Separator type="solid" />
        <div styleName="textbox-wrapper">
          <TextBox
            id={poolName.name}
            title={i18nBase('name_cf')}
            dataNemo="your-pool-name"
            isDisabled={!this.props.campaign.can_chip_in}
            {...poolName}
          />
        </div>
        <div styleName="textbox-wrapper">
          <MoneyTextBox
            id={goalAmount.name}
            title={getGoalAmountTitle(charity, formattedMaxGoalAmount)}
            dataNemo="goal-amount"
            disableCents={false}
            isDisabled={!this.props.campaign.can_chip_in}
            {...goalAmount}
          />
        </div>
        <div styleName="textbox-wrapper">
          <DateInputBox
            id={endDate.name}
            title={i18nBase('end_date_cf')}
            dataNemo="date-pool-ends"
            isDisabled={!this.props.campaign.can_chip_in}
            {...endDate}
          />
        </div>
        <br />
        <CaptionText styleName="detail-title">
          {i18n('about_titile_cf')}
        </CaptionText>
        <Separator type="solid" />
        {!charity && (
          <div styleName="category">
            <DropDown
              label={_get(i18n('category'), 'props.children', i18n('category'))}
              dataNemo="pool-category"
              formField={category}
            >
              {this.props.categoryList.map(categoryOption => {
                return (
                  <option
                    key={categoryOption.key}
                    value={categoryOption.value}
                    styleName="fs-option"
                  >
                    {categoryOption.label}
                  </option>
                )
              })}
            </DropDown>
          </div>
        )}
        <div styleName="description-container">
          <div styleName="textbox-wrapper">
            <TextBox
              {...description}
              id={description.name}
              dataNemo="about-pool-description"
              multiline={true}
              rows={DESCRIPTION_ROWS}
              title={i18n('description_cf')}
              onKeyUp={this.handleKeyUp}
              maxLength={CROWDFUNDING_DESCRIPTION_LENGTH}
            />
            <div styleName="char-count">
              {`${this.state.charCount}/${CROWDFUNDING_DESCRIPTION_LENGTH}`}
            </div>
          </div>
        </div>
        <CaptionText styleName="detail-title">
          {i18n('photo_titile_cf')}
        </CaptionText>
        <Separator type="solid" />
        {!this.props.isAndroid && (
          <div styleName="uploader">
            <CrowdFundingCoverImage fields={this.props.fields} />
          </div>
        )}

        {this.props.showDelete && (
          <Link
            styleName="delete-link"
            data-nemo="deletePool"
            onClick={this.handleDelete}
            onKeyUp={e => {
              if (e.key === 'Enter') {
                this.handleDelete()
              }
            }}
            tabIndex={0}
          >
            <TrashIcon styleName="delete-icon" />{' '}
            <span>{i18n('delete_cf_title')}</span>
          </Link>
        )}
        <button
          data-nemo="save"
          className="vx_btn vx_btn-block"
          styleName="save-button"
        >
          {i18n('save_cf')}
        </button>
        <button
          onClick={this.handleModalClick}
          styleName="btn"
          className={`vx_btn vx_btn-secondary vx_btn-block ${
            anyInactiveFieldsTouchedWithError ? 'vx_btn-disabled' : ''
          }`}
          disabled={anyInactiveFieldsTouchedWithError}
          data-nemo="preview-next"
          type="button"
        >
          {i18n('preview_cf')}
        </button>
        <Modal
          isOpen={this.state.isOpen}
          onClose={this.handleModalClose}
          styleName="modal"
          action={
            <HeadingText size="md" styleName="modal_title">
              {i18n('preview_cf')}
            </HeadingText>
          }
        >
          <CrowdFundingPreview
            isEdit={true}
            editedCampaign={this.state.editedCampagin}
          />
        </Modal>
      </form>
    )
  }
}

export default cssModules(EditMain, styles)
